<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense>mdi-filter</v-icon>
            {{ header }}
            <v-spacer v-if="headerButtonText" />
            <v-btn
              v-if="headerButtonText"
              elevation="2"
              class="mr-2"
              x-small
              @click="headerButtonAction"
              >{{ headerButtonText }}
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row>
              <global-dateTimeRangePicker @event-changed="handleEventChanged" />

              <global-stallholderFilterGroup
                v-if="showStallholders"
                :showTerminals="showTerminals"
                @event-changed="handleEventChanged"
              />
              <v-spacer v-else />
              <v-col
                cols="12"
                :md="showStallholders ? '12' : '2'"
                lg="2"
                class="text-right"
              >
                <div class="d-flex justify-end">
                  <v-btn
                    color="secondary"
                    class="mt-4 white--text mr-4"
                    :disabled="isTodayButtonDisabled"
                    @click="setToday"
                  >
                    Today
                    <v-icon dark right>mdi-calendar-today</v-icon>
                  </v-btn>
                  <v-btn
                    color="secondary"
                    class="mt-4 white--text mr-4"
                    @click="clear"
                  >
                    Clear
                    <v-icon dark right>mdi-calendar-today</v-icon>
                  </v-btn>
                  <v-btn
                    color="secondary"
                    class="mt-4 white--text"
                    @click="handleClickSubmit"
                  >
                    Submit
                    <v-icon right dark>mdi-magnify</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-expand-transition>
                  <div v-if="showTransactionFilters">
                    <v-row align="center">
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="deviceId"
                          label="Device ID"
                          dense
                          clearable
                          @click:append="clearDeviceId"
                        />
                      </v-col>
                      <v-col cols="12" md="1" class="text-center"> | </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="stan"
                          label="STAN"
                          dense
                          clearable
                          @click:append="clearStan"
                        />
                      </v-col>
                      <v-col cols="12" md="1" class="text-center"> Or </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="totalAmount"
                          label="Total Amount"
                          dense
                          clearable
                          type="number"
                          prefix="$"
                          @click:append="clearTotalAmount"
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-expand-transition>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import moment from "moment";

export default {
  props: {
    header: {
      type: String,
      default: null,
    },
    showStallholders: {
      type: Boolean,
      default: false,
    },
    showTerminals: {
      type: Boolean,
      default: false,
    },
    headerButtonText: {
      type: String,
      default: null,
    },
    headerButtonAction: {
      type: Function,
      default: null,
    },
    showTransactionFilters: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deviceId: "",
      stan: "",
      totalAmount: null,
    };
  },
  computed: {
    ...mapState({
      globalEventFilter: (state) => state.filter.globalEventFilter,
    }),
    isTodayButtonDisabled() {
      if (!this.globalEventFilter || !this.globalEventFilter.endDateTime) {
        return false;
      }

      const eventEndDate = moment(
        this.globalEventFilter.endDateTime,
        "YYYYMMDDHHmm"
      );
      const threeDaysAgo = moment().subtract(3, "days");

      return eventEndDate.isBefore(threeDaysAgo);
    },
  },
  watch: {
    deviceId(newVal) {
      this.setDeviceId(newVal || "");
    },
    stan(newVal) {
      this.setStan(newVal || "");
    },
    totalAmount(newVal) {
      this.setTotalAmount(newVal || null);
    },
  },
  methods: {
    ...mapActions("dashboard", ["updateDashboard"]),
    ...mapMutations("filter", [
      "setSearchStartTime",
      "setSearchEndTime",
      "setDeviceId",
      "setStan",
      "setTotalAmount",
    ]),
    setToday() {
      this.setSearchStartTime(moment().format("YYYYMMDD") + "0000");
      this.setSearchEndTime(moment().format("YYYYMMDD") + "2359");
      this.updateDashboard("EFM setToday");
    },
    clear() {
      this.setSearchStartTime("notSet");
      this.setSearchEndTime("notSet");
    },
    clearDeviceId() {
      this.deviceId = "";
      this.setDeviceId("");
    },
    clearStan() {
      this.stan = "";
      this.setStan("");
    },
    clearTotalAmount() {
      this.totalAmount = null;
      this.setTotalAmount(null);
    },
    handleEventChanged() {
      // this.updateDashboard("EFM globalEventFilter.EventId");
    },
    handleClickSubmit() {
      this.updateDashboard("EFM handleClickSubmit");
    },
  },
};
</script>

<style scoped>
.v-card {
  margin-bottom: 20px;
}
</style>
